export enum ThemeModeEnum {
  light,
  dark
}
